'use strict';

wbApp.controller('OneOffsSummaryCtrl', ['$scope', '$filter', '$translate', '$q', 'reportsSvc', 'semesterSvc', 'accountingBookSvc', 'groupSvc',
function ($scope, $filter, $translate, $q, reportsSvc, semesterSvc, accountingBookSvc, groupSvc) {

    $scope.groups = groupSvc.getAllAsync(true);
    $scope.customFilter = { groups: [], accountingBooks: [] };

    $scope.accountingBooks = accountingBookSvc.getAllAsync();
    $scope.rawOneOffsSummary = [];
    $scope.oneOffsSummary = [];


    function preFilter() {
        $q.all([$scope.rawOneOffsSummary.$promise, $scope.accountingBooks.$promise, $scope.groups.$promise]).then(function () {
            var groupIDs = _.values($scope.customFilter.groups);
            var accountingBookIDs = _.values($scope.customFilter.accountingBooks);
            var noGroupSelected = $scope.customFilter.groups.indexOf(-1) !== -1;
            $scope.oneOffsSummary.length = 0;
            $scope.oneOffsSummary.push.apply($scope.oneOffsSummary,
                _.filter($scope.rawOneOffsSummary, function (o) {
                    var ret = true;
                    if (noGroupSelected) {
                        ret = ret && !o.groups.length;
                    } else {
                        if (groupIDs.length > 0) {
                            ret = ret && _.intersection(o.groups, groupIDs).length > 0;
                        }
                    }
                    if (accountingBookIDs.length > 0) {
                        ret = ret && _.includes(accountingBookIDs, o.accountingBookID);
                    }
                    return ret;
                })
            );
        });
    }

    $scope.$watch('customFilter', function (newValue, oldValue) {
        preFilter();
    }, true);

    semesterSvc.getDefaultAsync()
        .then(function (semester) {
            $scope.semesterID = semester.id;
            $scope.rawOneOffsSummary = reportsSvc.getOneOffAttendanceSummary($scope.semesterID);
            preFilter();
        });

    $scope.$on('refreshData', function (e, data) {
        if ($scope.semesterID) {
            $scope.rawOneOffsSummary = reportsSvc.getOneOffAttendanceSummary($scope.semesterID);
            preFilter();
        }
    });

    $scope.onSemesterChange = function (semesterID) {
        if (semesterID) {
            $scope.rawOneOffsSummary = reportsSvc.getOneOffAttendanceSummary($scope.semesterID);
            preFilter();
        }
    }

    $scope.gridSettings = {
        name: 'oneOffsSummary',
        shouldShowColumnChooser: true,
        columns: [
        { dataField: 'studentSurname', caption: $translate.instant('TXT_HUMAN_SURNAME'), dataType: 'string', width: '110px' },
        { dataField: 'studentName', caption: $translate.instant('TXT_HUMAN_NAME'), dataType: 'string', width: '110px' },
        { dataField: 'studentMiddlename', caption: $translate.instant('TXT_LBL_MIDDLENAME'), dataType: 'string', width: '110px' },
        {
            dataField: 'courseName',
            caption: $translate.instant('TXT_LBL_COURSE'),
            dataType: 'string',
            calculateCellValue: function (rowData) {
                var ret = rowData.subjectName;
                if (!!rowData.courseAbbreviation) {
                    ret += " (" + rowData.courseAbbreviation + ")";
                }

                if (!!rowData.courseName) {
                    ret += " - " + rowData.courseName;
                }

                return ret;
            }
        },
        { dataField: 'lessonStartTime', caption: $translate.instant('TXT_LBL_START_DATE'), dataType: 'date', format: { raw: "dd.MM.yy EEE HH:mm" }, width: '130px', sortOrder: 'asc' },
        { dataField: 'lessonEndTime', caption: $translate.instant("TXT_LBL_END_DATE"), dataType: 'date', format: { raw: "HH:mm" }, width: '60px' },
        { dataField: 'price', caption: $translate.instant('TXT_LBL_PRICE'), dataType: 'number', format: { type: 'currency', precision: 2 }, width: '90px' },
        {
            dataField: 'courseAttendanceStatusID',
            caption: $translate.instant('TXT_COL_ATTENDANCE_STATUS'),
            dataType: 'string',
            width: '90px',
            calculateCellValue: function (rowData) {
                return $filter('attendanceStatus')(rowData.courseAttendanceStatusID);
            }
        },
        {
            dataField: 'studentBirthday',
            caption: $translate.instant('TXT_LBL_BIRTHDAY'),
            dataType: 'date',
            format: { date: 'short' },
            width: '70px',
            alignment: 'right'
        },
        {
            dataField: 'parentSurname',
            caption: $translate.instant('TXT_LBL_PARENT'),
            dataType: 'string',
            width: '140px',
            calculateCellValue: function (rowData) {
                return String.prototype.fullName(rowData.parentName, rowData.parentMiddlename, rowData.parentSurname);
            }
        },
        {
            dataField: 'parentPhone',
            caption: $translate.instant('TXT_LBL_PHONE'),
            dataType: 'string',
            width: '120px',
            calculateCellValue: function (rowData) {
                return $filter('phone')(rowData.parentPhone);
            }
        },
        { dataField: 'parentEmail', caption: $translate.instant('TXT_LBL_EMAIL'), dataType: 'string', width: '160px' },
        { dataField: 'parentAddress', caption: $translate.instant('TXT_LBL_ADDRESS'), dataType: 'string', visible: false },
        {
            dataField: 'groups',
            caption: $translate.instant('TXT_MENU_GROUPS'),
            dataType: 'object',
            calculateCellValue: function (rowData) {
                return $filter('groups')(rowData.groups);
            },
            visible: false
        },
        ]
    }
}]);
